interface PrettyPrintJsonProps {
  data: unknown;
}

export const PrettyPrintJson = ({ data }: PrettyPrintJsonProps) => (
  <div>
    <pre>{JSON.stringify(data, null, 2)}</pre>
  </div>
);
